import { cn } from '../cn';

export interface CheckboxProps {
  checked: boolean;
  onChange?: (v: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

/** 16 × 16, radius 4; on = fg fill with a 700 10px mono ✓ in bg; off = border2 outline. */
export function Checkbox({ checked, onChange, label, disabled, className }: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onChange?.(!checked);
      }}
      className={cn(
        'flex h-4 w-4 flex-none items-center justify-center rounded-sm p-0 font-mono text-xs font-bold leading-none text-bg',
        checked ? 'border-0 bg-fg' : 'border border-border2 bg-transparent',
        className,
      )}
    >
      {checked ? '✓' : ''}
    </button>
  );
}
